import React, { createContext, useReducer, useContext } from 'react';
import { streamChatResponse } from '../repositories/openaiService';
import * as agentService from '../repositories/agentService'
import ChatMessage, { MessageRole } from '../models/chat_message';

// Initial State
const initialState = {
  messages: [],
  isLoading: false,
  error: null,
};

// Reducer Function
const chatReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_MESSAGE':
          /** @type {ChatMessage} */
  let lastMessage = state.messages[state.messages.length - 1];
  if (lastMessage && lastMessage.role === action.payload.role) {
    // Merge consecutive messages immutably
    let content = action.payload.type=='line'?`${action.payload.content}<br/>` : action.payload.content;
    const updatedMessage = {
      ...lastMessage,
      
      content: lastMessage.content + content,
    };
    return {
      ...state,
      messages: [...state.messages.slice(0, -1), updatedMessage],
    };
  }


  return { ...state, messages: [...state.messages, action.payload] };

    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_ERROR':

      return { ...state, error: action.payload, 
        messages: [...state.messages, action.payload] };
    case 'SET_THREAD_ID': // New action to set threadId
      return { ...state, threadId: action.payload };
    default:
      return state;
  }
};

// Context
const ChatContext = createContext();

// Provider
export const ChatProvider = ({children }) => {
  const [state, dispatch] = useReducer(chatReducer, initialState);

  // Handle sending a new message
  const sendMessage = async (chatType, input) => {
    console.log('sendMessage',input);
    dispatch({ type: 'SET_LOADING', payload: true });

    const message = new ChatMessage({
      role: 'user',
      content: input
    });

    // Add user's message
    dispatch({ type: 'ADD_MESSAGE', payload: message });

    try {
        let streamedContent = '';
        let threadId;
        /** @type {ChatMessage[]} */
        let _messages = state.messages;
        if(state.messages.length){
          /// Get the last message with role assistant
          var lastAssistantMessage = _messages.find((message) => message.role === MessageRole.ASSISTANT);
          
            if(lastAssistantMessage){
              threadId = lastAssistantMessage.threadId;
              console.log('threadId',threadId);
            }
           
        }

        if(chatType == ChatType.NORMAL){
          await streamChatResponse(
            input,
            threadId, // Pass threadId to the service
            (partialResponse, isFirstChunk) => {
              if (isFirstChunk) {
                // Extract and store threadId from the first chunk
                const threadId = partialResponse.thread_id;
              //   dispatch({ type: 'SET_THREAD_ID', payload: threadId });
                const message = new ChatMessage({
                  role: MessageRole.ASSISTANT,
                  content: '',
                  threadId,
                });
                dispatch({ type: 'ADD_MESSAGE', payload: message });
              } else {
                streamedContent = partialResponse;
  
                // Update assistant's message dynamically
                dispatch({
                  type: 'ADD_MESSAGE',
                  payload: {role: MessageRole.ASSISTANT, ...streamedContent},
                });
              }
            }
          );
        }else{
          const previousMessages = agentService.getPreviousMessages(_messages);
          const prompt = {
            text: input
          }
          const userInfo = {
            userId: 'aMV9LDSZqVzEQ0qLof24',
            name: 'developer'
          }
           const response = await agentService.getChatResponse({prompt,previousMessages, userInfo});
           let message = new ChatMessage({
            role: MessageRole.ASSISTANT,
            content: 'Failed to get the message from the agent',

           });
           if(response.content && response.content.length){
             message.content = response.content[0].text;
           }

           dispatch({
            type: 'ADD_MESSAGE',
            payload: message,
          });

        }
        

      dispatch({ type: 'SET_LOADING', payload: false });
    } catch (error) {
      dispatch({ type: 'SET_ERROR', payload: new ChatMessage({
        role: MessageRole.ASSISTANT,
      content: error.message,
    isError: true})});
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  };

  return (
    <ChatContext.Provider value={{ state, sendMessage }}>
      {children}
    </ChatContext.Provider>
  );
};

// Hook to use Chat Context
export const useChat = () => useContext(ChatContext);

/** ChatType */
export const ChatType = {
  NORMAL: 'normal',
  AGENT: 'agent',
};